import React from 'react'
import { useSelector } from 'react-redux'
import { IconLogo } from 'assets/icons'
import PremiumLogo from 'assets/new-icons/icon-logo-circle-premium.svg'
import { useProIcon } from 'utils/proIcon'
import BusinessSelector from 'pages/NewDashboard/components/BusinessSelector'
import BellNotification from 'pages/NewDashboard/components/Header/BellNotification'
import { useAbExperiment } from 'utils/useAbExperiment'
import { IAppState } from 'infra/AppState'
import UploadSupplySheet from '../CommonDrawers/UploadSheetDrawers/UploadSupplySheet'
import RefreshButton from './RefreshButton'
import { TopHeaderStyles } from './styles'

const TopHeader = () => {
  const classes = TopHeaderStyles()
  const { downtime } = useAbExperiment()
  // Premium ("Pro") icon: subscribed and not opted out (utils/proIcon)
  const { premium } = useProIcon()

  const { currentBusinessConfig } = useSelector((app: IAppState) => app.Dashboard)
  const isUploadVisible = currentBusinessConfig?.visible_screens?.upload_supply_sheet?.access_type
    ? currentBusinessConfig?.visible_screens?.upload_supply_sheet?.access_type !== 'read'
    : true

  return (
    <div className={classes.topHeaderContainer}>
      <div className={classes.innerContainer}>
        <div className={classes.logoBusinessContainer}>
          <div className={classes.logoSlot}>
            <img
              className={classes.logoStyles}
              data-keep-colors
              src={premium ? PremiumLogo : IconLogo}
              alt="OkCredit Logo"
              role="button"
              tabIndex={0}
              onClick={() => window.location.reload()}
            />
          </div>
          <BusinessSelector />
          <RefreshButton />
          {downtime && <BellNotification />}
        </div>
        {!isUploadVisible ? null : <UploadSupplySheet />}
      </div>
    </div>
  )
}

export default TopHeader
